import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const Wrapper = styled('section')`
  position: relative;
  color: ${({ theme }) => theme.color.white};
  background: ${({ theme }) => theme.color.noir};
  padding: ${({ theme }) => theme.x1spacePx}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.lgUp`
    border-radius: ${({ theme }) => theme.x1spacePx}px;
    margin-bottom: 12px;
  `}
`;

export const Title = styled('h2')`
  ${({ theme }) => theme.typography.small}
  padding: ${({ theme }) => theme.x1spacePx}px;
  margin: 0;
  margin-top: ${({ theme }) => theme.x1spacePx / 2}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const Company = styled(Row)`
  padding: ${({ theme }) => `${theme.x2spacePx - 6}px ${theme.x1spacePx}px`};
  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  h3,
  p {
    margin: 0;
  }
  h3 {
    ${({ theme }) => theme.typography.xSmallStrong}
  }
  p {
    ${({ theme }) => theme.typography.tiny}
    color: ${({ theme }) => theme.color.white};
    opacity: 0.5;
  }
`;

export const Added = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  > svg {
    margin: ${({ theme }) => `0 ${theme.x1spacePx / 2}px`};
    margin-bottom: ${({ theme }) => -theme.x1spacePx}px;
    > * {
      fill: ${({ theme }) => theme.color.good};
    }
  }
`;
